import Component from "../../component";

const TogglerComponentConfig = {
    baseHtmlClass: 'nav_menu_toggler',
    selector: '.nav_menu_toggler'
};

export default class TogglerComponent extends Component {

    static newMany(navMenu) {
        if (!navMenu.element) return null;
        const togglerSelector = `.${ TogglerComponentConfig.baseHtmlClass }--${ navMenu.id }`
        let elements = document.querySelectorAll(togglerSelector);
        if (!elements) return null;
        let togglers = [];
        elements.forEach((element) => { togglers.push( new TogglerComponent(element, navMenu)) });
        return togglers;
    }

    constructor(id_or_element, navMenu) {
        super({
            element: id_or_element,
            config: TogglerComponentConfig
        });

        this.navMenu = navMenu;
        this.element.addEventListener('click', this.handleClick.bind(this));
        this.listening = true;
    }

    toggleOpenState() {
        this.navMenu.open = !this.state().open;
    }

    handleClick(event) {
        if (this.state().closed) this.navMenu.opening = true;
        if (this.state().open) this.navMenu.closing = true;

        if(this.state().opening) this.navMenu.storeScrollPosition();

        this.toggleOpenState();

        if (this.listening) {
            window.requestAnimationFrame(()=>{
                this.navMenu.render();

                this.navMenu.closing = false;
                this.navMenu.opening = false;

                this.listening = true;
            });
            this.listening = false;
        }
        event.preventDefault();
    }

    state() {
        return this.navMenu.state();
    }

    render() {
        this.conditionallySetHtmlClassState(this.state().open, 'open');
    }

}